import styles from './PageLayoutWithNavMenu.module.scss';
import { Outlet, useLocation } from 'react-router-dom';
import { LeftSidePanel } from 'src/v2/components/LeftSidePanel';
import { useEffect, useContext } from 'react';
import {
  useBanner,
  useBreakpoint,
  useLeftPanelActions,
  useLeftPanelState,
} from 'src/hooks';
import {
  APINestedRoutes,
  AppRoutes,
  LeftPanelSections,
  UserSettingsNestedRoutes,
} from 'src/types';
import cn from 'classnames';
import AuthContext from 'src/contexts/AuthContext';

export const PageLayoutWithNavMenu = () => {
  const { pathname } = useLocation();
  const { setLeftPanelData } = useLeftPanelActions();
  const { leftPanelSections } = useLeftPanelState();
  const { isMobileOrTablet } = useBreakpoint();
  const { bannersSet } = useBanner();
  const { isGuestAccess } = useContext(AuthContext);

  useEffect(() => {
    if (pathname === AppRoutes.HOME) {
      return;
    }

    if (
      Object.values(APINestedRoutes).some((value) =>
        pathname.includes(value),
      ) &&
      leftPanelSections !== LeftPanelSections.API_MANAGEMENT
    ) {
      setLeftPanelData({
        panelType: LeftPanelSections.API_MANAGEMENT,
        isExpanded: !isMobileOrTablet,
      });
      return;
    }

    if (
      Object.values(UserSettingsNestedRoutes).some((value) =>
        pathname.includes(value),
      ) &&
      leftPanelSections !== LeftPanelSections.USER_MENU
    ) {
      setLeftPanelData({
        panelType: LeftPanelSections.USER_MENU,
        isExpanded: !isMobileOrTablet,
      });
      return;
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return (
    <div
      className={cn(styles.containerWrapper, {
        [styles.reducedHeight]: bannersSet.length !== 0,
      })}
    >
      {!isGuestAccess && <LeftSidePanel />}
      <Outlet />
    </div>
  );
};
